import { emitCacheUpdateEvent } from "./events";
import { getQueryKey } from "./utils";
export class RequestCacheEntry {
    key;
    _promisedResponse;
    createdAt;
    constructor({ key, value }) {
        this.key = key;
        this._promisedResponse = value;
        this.createdAt = new Date();
        emitCacheUpdateEvent(this);
    }
    isStale(staleTimeOption) {
        if (!staleTimeOption) {
            return false;
        }
        const staleDate = this.createdAt.getTime() + staleTimeOption;
        return staleDate < Date.now();
    }
    get value() {
        /** Response can be only consumed once. so always keep the original and return clones */
        return this._promisedResponse.then((r) => r.clone());
    }
}
export class RequestCacheClient {
    cache;
    constructor() {
        this.cache = {};
    }
    getEntry(url) {
        return this.cache[getQueryKey(url)] || null;
    }
    createEntry(url, promisedResponse) {
        const key = getQueryKey(url);
        this.cache[getQueryKey(url)] = new RequestCacheEntry({
            key,
            value: promisedResponse,
        });
    }
}
